module.exports = __webpack_public_path__ + "c4e88a78621ec2ba141625da823469f6.pdf";